export { default } from './PaymentMethods.data';
